import type { ADF } from '@atlassian/jira-rich-content';
import type { ImmutableState } from '../types';

export const getSignature = (state: ImmutableState): ADF | null | undefined => state.signature;
